// @flow
import $ from 'jquery';
import JQueryView, { on } from '../../../common/JQueryView';

export default class IndexView extends JQueryView {
  constructor() {
    super('.full-screen-form-page');
  }

  @on({ event: 'change', selector: 'input[name="from_stakeholder_id"]:radio' })
  onChangeFromStockholder(event: any) {
    const fromStockholderName = $(event.target)
      .closest('td')
      .next()
      .children('div:nth-child(1)')
      .text();
    $('#from_stakeholder_name')
      .text(fromStockholderName)
      .addClass('font-weight-bold')
      .removeClass('text-primary');
  }

  @on({ event: 'change', selector: 'input[name="to_stakeholder_id"]:radio' })
  onChangeToStockholder(event: any) {
    const toStakeholderName = $(event.target)
      .closest('td')
      .next()
      .children('div:nth-child(1)')
      .text();
    $('#to_stakeholder_name')
      .text(toStakeholderName)
      .addClass('font-weight-bold')
      .removeClass('text-primary');
  }
}
